// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-components-___Header__header___ONXAw {
  background-color: #4ca92f;
  display: flex;
  align-items: center;
  height: 4em;
  padding-left: 1em;
  flex-direction: row;
  justify-content: space-between;
}
.src-styles-components-___Header__title___vEtZA {
  display: inline-flex;
  margin: 0;
}
.src-styles-components-___Header__title___vEtZA a {
  color: #ffffff;
}
.src-styles-components-___Header__title___vEtZA a:hover {
  color: #e6e6e6;
}
.src-styles-components-___Header__logout___CneZg {
  color: #ffffff;
}
.src-styles-components-___Header__logout___CneZg:hover {
  cursor: pointer;
  color: #e6e6e6;
}
.src-styles-components-___Header__super-button___enFYv {
  font-size: 1em;
  text-align: center;
  border: none;
  color: #4ca92f;
  background: #ffffff;
  margin-top: 0.2em;
  outline: none;
}
.src-styles-components-___Header__logout-action___rEmEd {
  min-width: 100px;
  padding-left: 3rem;
  margin-right: 0rem;
  float: right;
}
.src-styles-components-___Header__actions-container___bYCz4 {
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  float: right;
  margin-top: 0em;
  /* margin-bottom: 0.3em; */
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}
.src-styles-components-___Header__actions____axNB {
  color: #ffffff;
  margin-right: 0;
  max-width: 300px;
  min-width: 200px;
}
.src-styles-components-___Header__menu-container___x1Uzv {
  /* background-color: @color-main-green; /* aquamarine; */
  display: flex;
  max-height: 64px;
}
.src-styles-components-___Header__lang-menu-button___mMA_m {
  max-height: 20px;
  float: right;
}
.src-styles-components-___Header__lang-menu___hGhX6 {
  /* visibility: hidden; */
  color: #4ca92f;
  color: black;
}
.src-styles-components-___Header__lang-menu___hGhX6:focus-within,
.src-styles-components-___Header__lang-menu___hGhX6:hover {
  visibility: visible;
  color: #ffffff;
}
.src-styles-components-___Header__lang-menu-hidden___Jp3D1 {
  visibility: hidden;
}
.src-styles-components-___Header__lang-menu-dots___YdXQr {
  background: #4ca92f;
  border: 0;
  padding-top: 9px;
}
.src-styles-components-___Header__Select-menu-outer___P_X09 {
  background: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/Header.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAIA;EACE,oBAAA;EACA,SAAA;AAFF;AAAA;EAKI,cAAA;AAFJ;AAII;EACE,cAAA;AAFN;AAOA;EACE,cAAA;AALF;AAME;EACE,eAAA;EACA,cAAA;AAJJ;AAQA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AANF;AASA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAPF;AAUA;EACE,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EARA,0BAA0B;EAU1B,cAAA;EACA,eAAA;EACA,WAAA;AARF;AAWA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AATF;AAYA;EAVE,wDAAwD;EAYxD,aAAA;EACA,gBAAA;AAVF;AAaA;EACE,gBAAA;EACA,YAAA;AAXF;AAcA;EAZE,wBAAwB;EAcxB,cAAA;EACA,YAAA;AAZF;AAaE;;EACE,mBAAA;EACA,cAAA;AAVJ;AAcA;EACE,kBAAA;AAZF;AAeA;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;AAbF;AAgBA;EACE,eAAA;AAdF","sourcesContent":["@import '../variables.less';\n\n.header {\n  background-color: @color-main-green;\n  display: flex;\n  align-items: center;\n  height: @height-header;\n  padding-left: 1em;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.title {\n  display: inline-flex;\n  margin: 0;\n\n  a {\n    color: @color-main-white;\n\n    &:hover {\n      color: darken(@color-main-white, 10%);\n    }\n  }\n}\n\n.logout {\n  color: @color-main-white;\n  &:hover {\n    cursor: pointer;\n    color: darken(@color-main-white, 10%);\n  }\n}\n\n.super-button {\n  font-size: 1em;\n  text-align: center;\n  border: none;\n  color: @color-main-green;\n  background: @color-main-white;\n  margin-top: 0.2em;\n  outline: none;\n}\n\n.logout-action {\n  min-width: 100px;\n  padding-left: 3rem;\n  margin-right: 0rem;\n  float: right;\n}\n\n.actions-container {\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  float: right;\n  margin-top: 0em;\n  /* margin-bottom: 0.3em; */\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n}\n\n.actions {\n  color: @color-main-white;\n  margin-right: 0;\n  max-width: 300px;\n  min-width: 200px;\n}\n\n.menu-container {\n  /* background-color: @color-main-green; /* aquamarine; */\n  display: flex;\n  max-height: 64px;\n}\n\n.lang-menu-button {\n  max-height: 20px;\n  float: right;\n}\n\n.lang-menu {\n  /* visibility: hidden; */\n  color: @color-main-green;\n  color:black;\n  &:focus-within, &:hover {\n    visibility: visible;\n    color: @color-main-white;\n  }\n}\n\n.lang-menu-hidden {\n  visibility: hidden;\n}\n\n.lang-menu-dots {\n  background: @color-main-green;\n  border: 0;\n  padding-top: 9px;\n}\n\n.Select-menu-outer {\n  background: red;\n}"],"sourceRoot":""}]);
// Exports
export var header = `src-styles-components-___Header__header___ONXAw`;
export var title = `src-styles-components-___Header__title___vEtZA`;
export var logout = `src-styles-components-___Header__logout___CneZg`;
var _1 = `src-styles-components-___Header__super-button___enFYv`;
export { _1 as "super-button" };
var _2 = `src-styles-components-___Header__logout-action___rEmEd`;
export { _2 as "logout-action" };
var _3 = `src-styles-components-___Header__actions-container___bYCz4`;
export { _3 as "actions-container" };
export var actions = `src-styles-components-___Header__actions____axNB`;
var _4 = `src-styles-components-___Header__menu-container___x1Uzv`;
export { _4 as "menu-container" };
var _5 = `src-styles-components-___Header__lang-menu-button___mMA_m`;
export { _5 as "lang-menu-button" };
var _6 = `src-styles-components-___Header__lang-menu___hGhX6`;
export { _6 as "lang-menu" };
var _7 = `src-styles-components-___Header__lang-menu-hidden___Jp3D1`;
export { _7 as "lang-menu-hidden" };
var _8 = `src-styles-components-___Header__lang-menu-dots___YdXQr`;
export { _8 as "lang-menu-dots" };
var _9 = `src-styles-components-___Header__Select-menu-outer___P_X09`;
export { _9 as "Select-menu-outer" };
export default ___CSS_LOADER_EXPORT___;
